import { Link } from 'react-router-dom';

export default function FeaturedArtistSlots({
    artists = [],
    slotCount = 6,
}) {
    const hasAvailableSlots = artists.length < slotCount;

    const slots = [
        ...artists,
        ...(hasAvailableSlots ? [null] : []),
    ];

    return (
        <div className="bjnt-featured-artist-slots">
            {slots.map((artist, index) => (
                <article
                    key={artist?.id || `artist-slot-${index}`}
                    className={`bjnt-featured-artist-slot ${artist ? 'is-filled' : 'is-empty'
                        }`}
                >
                    {artist ? (
                        <>
                            <Link
                                to={`/artist/${artist.slug}`}
                                className="bjnt-featured-artist-slot__avatar"
                            >
                                {artist.image ? (
                                    <img src={artist.image} alt="" />
                                ) : (
                                    <span />
                                )}
                            </Link>

                            <div className="bjnt-featured-artist-slot__body">
                                <p>Featured Artist</p>

                                <h3>
                                    <Link to={`/artist/${artist.slug}`}>
                                        {artist.name}
                                    </Link>
                                </h3>

                                <span>
                                    {artist.tagline || 'Artist Spotlight'}
                                </span>
                            </div>
                        </>
                    ) : (
                        <div className="bjnt-featured-artist-slot__empty">
                            <p>Featured Artist Slot Available</p>

                            <h3>Your artist profile here</h3>

                            <span>
                                Promote your music, profile and latest releases.
                            </span>

                            <a
                                href="mailto:advertise@bajantube.com?subject=Featured%20Artist%20Slot"
                                className="bjnt-featured-artist-slot__book"
                            >
                                Get Featured
                            </a>
                        </div>
                    )}
                </article>
            ))}
        </div>
    );
}